import {CREATE, DELETE, FETCH_ALL, LIKE, UPDATE} from "../constants/actionTypes";

export default (posts = [], action) => {
    switch (action.type) {
        case UPDATE:
        case LIKE:
            return posts.map((post) => post._id === action.payload.id ? action.payload : post)
        case FETCH_ALL:
            return action.payload
        case CREATE:
            return [...posts, action.payload]
        case DELETE:
            return posts.filter((post) => post._id !== action.payload)
        default:
            return posts
    }
}
